import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import * as moment from 'moment';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { ParametrosModel } from 'src/app/models/parametros.model';
import { CustomDatepickerComponent, DatepickerComponent } from 'src/app/shared/components/datePicker/ajustado/datepicker.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-administrar-agendamiento-virtual',
  templateUrl: './administrar-agendamiento-virtual.component.html',
  styleUrls: ['./administrar-agendamiento-virtual.component.scss']
})
export class AdministrarAgendamientoVirtualComponent implements OnInit {

  //Variables para la configuración del rango de agendamiento virtual
  private parametroFechaInicio: ParametrosModel;
  private parametroFechaFin: ParametrosModel;
  public fechaInicio: Date;
  public fechaFin: Date;
  public placeholderDate: string;
  public isValid = false;

  //Variables para agregar nuevo festivo y carga de festivos
  public fechaNuevoFestivo: Date;
  public festivos: Array<string> = [];
  public festivosDate: Array<Date> = [];

  public customDatepickerComponent: DatepickerComponent;


  constructor(
    private utilService: UtilService,
    private urlService: UrlService,
    private global: GlobalService,
    private spiner: NgxSpinnerService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    //Consulta el párametro de fechas para el agendamiento virtual.
    this.consultarParametros();
    this.placeholderDate = ConstantesService.SELECCION_FECHA;
    this.fechaInicio = null;
    this.fechaFin = null;
    this.fechaNuevoFestivo = new Date();
  }

  private consultarParametros() {

    this.consultarFestivos();

    this.obtenerFechaValorParametro(ConstantesService.NOMBRE_PARAMETRO_FECHA_INICIAL).then(parametro => {
      this.parametroFechaInicio = parametro;
      let fecha = this.parametroFechaInicio.valor;
      this.fechaInicio = moment(fecha.toString(), 'D/M/YYYY').toDate();
    }).catch(err => {
      //TODO
    });

    this.obtenerFechaValorParametro(ConstantesService.NOMBRE_PARAMETRO_FECHA_FINAL).then(parametro => {
      this.parametroFechaFin = parametro;
      let fecha = this.parametroFechaFin.valor;
      this.fechaFin = moment(fecha.toString(), 'D/M/YYYY').toDate();
    }).catch(err => {
      //TODO
    });

  }


  /**
   * Este método se encarga de consultar el parámetro y generar un dto
   * @param nombreParametro 
   * @returns retorna un parametro DTO con toda la información.
   */
  public obtenerFechaValorParametro(nombreParametro: String): Promise<ParametrosModel> {
    return new Promise((resolve, reject) => {
      const serviceProvider = 'parametroPorNombre';
      const queryParams: Array<[string, string]> = new Array<[string, string]>();
      queryParams.push(['nombreParametro', (nombreParametro.toString())]);
      const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
      this.global.getGenerico(url).subscribe(
        data => {
          let parametrosModel: ParametrosModel = data;
          resolve(parametrosModel);
        }, err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  /**
   * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
   */
  public handlerDatePickeRInicio(event) {
    this.fechaInicio = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
  }

  /**
   * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
   */
  public handlerDatePickeRFin(event) {
    this.fechaFin = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
  }


  /**
   * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
   */
  public handlerDatePickeNuevoFestivo(event) {
    this.fechaNuevoFestivo = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
  }



  /**
   * Este método actualiza las dos fechas lanzando las dos 
   * promesas al tiempo para enviar un solo mensaje al front.
   */
  public actualizarFechasAgendamiento() {
    if (this.fechaInicio != null && this.fechaFin != null) {
      if (moment(this.fechaInicio).isSameOrAfter(moment(this.fechaFin))) {
        this.alertService.generateAlertError("Fecha inicial no puede ser igual o superior a fecha final", "");
      } else {
        this.parametroFechaInicio.valor = moment(this.fechaInicio).format('D/M/YYYY');
        this.parametroFechaFin.valor = moment(this.fechaFin).format('D/M/YYYY');
        Promise.all([this.actualizarParametro(this.parametroFechaInicio),
        this.actualizarParametro(this.parametroFechaFin)]).then(resps => {
          this.alertService.generateAlertSuccess("Se han actualizado las fechas", "");
        });
      }
    }
  }

  /**
   * Ejecuta un PUT para actualizar un párametro
   * 
   * @param parametrosModel retorna una promesa de la actualización de un parámetro
   * @returns 
   */
  private actualizarParametro(parametrosModel: ParametrosModel): Promise<ParametrosModel> {
    return new Promise((resolve, reject) => {
      try {
        let usuario = JSON.parse(sessionStorage.getItem('Usuario'));
        parametrosModel.usuarioModificacion = usuario.userid;
        parametrosModel.fechaModificacion = new Date();
        const serviceProvider = 'ObtenerParametros';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.putGenerico(url, parametrosModel)
          .subscribe(data => {
            resolve(data);
          }, error => {
            this.spiner.hide();
            this.alertService.generateAlertError(error.message, 'Error');
            reject();
          });
      } catch (error) {
        this.spiner.hide();
        this.alertService.generateAlertError(error.message, 'Error');
      }
    });
  }

  /**
   * Obtiene un listado de días festivo 1 año hacia atrás
   *  y 1 año hacia adelante a partir de la fecha actual.
   * @returns promesa de arreglo de strings
   */

  private consultarFestivos() {
    const serviceProvider = 'obtenerRangoFestivosAnual';
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
    this.global.getGenerico(url).subscribe(
      data => {
        this.festivos = data;
        this.festivosDate = []
        this.festivos.forEach(festivo => {
          this.festivosDate.push(moment(festivo, "YYYY-MM-DD").toDate());
        });
      }, err => {
        console.log(err);
        this.alertService.generateAlertError('No es posible obtener los festivos', 'Error');
      }
    );
  }

  /**
   * Consume servicio post al api UAC para crear el festivo.
   */
  public crearFestivo() {

    this.spiner.show();

    const serviceProvider = 'crearFestivo';
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
    this.global.postGenerico(url, JSON.stringify({ date: this.fechaNuevoFestivo })).subscribe(
      data => {
        this.alertService.generateAlertSuccess("Se ha agregado un nuevo festivo", "");
        this.consultarFestivos();
        this.spiner.hide();
      },
      err => {
        console.log(err);
        this.alertService.generateAlertError(err.error.message, "Error");
        this.spiner.hide();
      }
    );
  }

  /**
   * Consume servicio post al api UAC para eliminar el festivo.
   * @param date fecha
   */
  public eliminarFestivo(date: Date) {

    this.spiner.show();

    const serviceProvider = 'eliminarFestivo';
    const url = this.urlService.getUrlUAC(
      new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
    this.global.postGenerico(url, JSON.stringify({ date: date })).subscribe(
      data => {
        this.alertService.generateAlertSuccess("Se ha eliminado un día festivo", "");
        this.consultarFestivos();
        this.spiner.hide();
      },
      err => {
        console.log(err);
        this.alertService.generateAlertError(err.error.message, "Error");
        this.spiner.hide();
      }
    );
  }
}
